import { PlayerInfoWithProjectionsFragment, TeamInfoWithPlayersFragment } from '@/api/events/query.generated';
import { EventInfo, isIndividualEvent, isTeamEvent } from '@/api/events/types/types';

import { PlayerProjection } from '../types';
import { createPlayerEventKey } from './markets-cache-store-utils';

export const eventUtils = {
    getAllPlayers: (event?: EventInfo): PlayerInfoWithProjectionsFragment[] => {
        let players: PlayerInfoWithProjectionsFragment[] = [];
        if (isTeamEvent(event)) {
            players = event.teams.reduce((acc: PlayerInfoWithProjectionsFragment[], team) => {
                return [...acc, ...(team.players ?? [])];
            }, []);
        } else if (isIndividualEvent(event)) {
            players = event.players ?? [];
        }
        return players ?? [];
    },

    /**
     * Maps all players from the given events to a record where the key is the player ID + event ID
     */
    getAllPlayersAsMap: (events?: EventInfo[]): Record<string, PlayerProjection[]> => {
        const allPlayersMarkets: Record<string, PlayerProjection[]> = {};
        events?.forEach(event => {
            const players = eventUtils.getAllPlayers(event);
            players.forEach(player => {
                const key = createPlayerEventKey(player.id, event.id);
                allPlayersMarkets[key] = player.projections;
            });
        });
        return allPlayersMarkets;
    },

    getTeams: (
        event?: EventInfo
    ): [TeamInfoWithPlayersFragment, TeamInfoWithPlayersFragment] | [undefined, undefined] => {
        if (isTeamEvent(event)) {
            return [event.teams[0], event.teams[1]];
        } else {
            return [undefined, undefined];
        }
    },

    getTeamById: (event?: EventInfo, teamId?: string): TeamInfoWithPlayersFragment | undefined => {
        if (isTeamEvent(event)) {
            return event.teams.find(team => team.id === teamId);
        }
        return undefined;
    },

    eventContainsPlayer: (event: EventInfo, playerId: string): boolean => {
        return eventUtils.getAllPlayers(event).some(player => player.id === playerId);
    },
};
